import { render, staticRenderFns } from "./fcsd_pls_bingqiku.vue?vue&type=template&id=60a7a8e4&scoped=true"
import script from "./fcsd_pls_bingqiku.vue?vue&type=script&lang=js"
export * from "./fcsd_pls_bingqiku.vue?vue&type=script&lang=js"
import style0 from "./fcsd_pls_bingqiku.vue?vue&type=style&index=0&id=60a7a8e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a7a8e4",
  null
  
)

export default component.exports